var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "b-form-group",
            [
              _c("b-validated-input-group-form-input", {
                attrs: {
                  id: "base_url",
                  label: _vm.$t("admin.base_url"),
                  "input-group-size": "mb-3",
                  rules: "required",
                  type: "url",
                  tooltip:
                    "This URL is used to construct links back to Dependency-Track from external systems.",
                },
                model: {
                  value: _vm.baseUrl,
                  callback: function ($$v) {
                    _vm.baseUrl = $$v
                  },
                  expression: "baseUrl",
                },
              }),
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: {
                      id: "isBadgesEnabled",
                      color: "primary",
                      label: "",
                    },
                    model: {
                      value: _vm.isBadgesEnabled,
                      callback: function ($$v) {
                        _vm.isBadgesEnabled = $$v
                      },
                      expression: "isBadgesEnabled",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(_vm._s(_vm.$t("admin.enable_svg_badge")) + "\n    "),
            ],
            1
          ),
          _c(
            "b-form-group",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("admin.default_language"),
                    "label-size": "lg",
                    "label-class": "font-weight-bold pt-0 mb-2",
                  },
                },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("admin.default_language_desc"))),
                  ]),
                  _c(
                    "div",
                    { attrs: { id: "customToolbar" } },
                    [
                      _c(
                        "c-switch",
                        _vm._b(
                          {
                            attrs: {
                              id: "default-language-enabled",
                              color: "primary",
                              label: "",
                            },
                            model: {
                              value: _vm.isDefaultLanguageEnabled,
                              callback: function ($$v) {
                                _vm.isDefaultLanguageEnabled = $$v
                              },
                              expression: "isDefaultLanguageEnabled",
                            },
                          },
                          "c-switch",
                          _vm.labelIcon,
                          false
                        )
                      ),
                      _vm._v(
                        _vm._s(_vm.$t("admin.default_language_enable")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "b-input-group",
                [
                  _c(
                    "b-input-group-prepend",
                    {
                      attrs: {
                        title: this.$t("message.language"),
                        "is-text": "",
                      },
                    },
                    [_c("span", { staticClass: "fa fa-language text-primary" })]
                  ),
                  _c(
                    "b-form-select",
                    {
                      staticClass: "bg-widget",
                      attrs: { disabled: !_vm.isDefaultLanguageEnabled },
                      model: {
                        value: _vm.defaultLanguage,
                        callback: function ($$v) {
                          _vm.defaultLanguage = $$v
                        },
                        expression: "defaultLanguage",
                      },
                    },
                    _vm._l(_vm.$i18n.availableLocales, function (locale) {
                      return _c(
                        "b-form-select-option",
                        {
                          key: `locale-${locale}`,
                          attrs: {
                            value: locale,
                            title: _vm.$t(`language.${locale}`),
                          },
                        },
                        [
                          _c("span", { staticClass: "mr-2" }, [
                            _vm._v(_vm._s(_vm.localeToFlag(locale))),
                          ]),
                          _vm._v(
                            "\n            " + _vm._s(locale.toUpperCase())
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: {
                variant: "outline-primary",
                disabled:
                  this.isDefaultLanguageEnabled && this.defaultLanguage === "",
              },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }